import { render, staticRenderFns } from "./paymentPolicy.vue?vue&type=template&id=812b48aa"
import script from "./paymentPolicy.vue?vue&type=script&lang=js"
export * from "./paymentPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports